import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../../defaultTheme";
import { rtlSpacing } from "../../utils/rtl";
var StyledTripLayover = styled.div.withConfig({
  displayName: "TripLayover__StyledTripLayover",
  componentId: "sc-1uzfgjz-0"
})(["margin:", ";"], function (_ref) {
  var theme = _ref.theme;
  return rtlSpacing("".concat(theme.orbit.spaceSmall, " 0 ").concat(theme.orbit.spaceSmall, "\n    ").concat(theme.orbit.spaceLarge));
});
StyledTripLayover.defaultProps = {
  theme: defaultTheme
};

var TripLayover = function TripLayover(_ref2) {
  var children = _ref2.children,
      dataTest = _ref2.dataTest;
  return React.createElement(StyledTripLayover, {
    "data-test": dataTest
  }, children);
};

export default TripLayover;